import { Flex } from '@chakra-ui/react';
import React from 'react';

import { Icon } from 'packages/common-frontend/components/icons';

export const ExpandAndCollapseButton = ({
  type,
  onClick,
}: {
  type: 'expand' | 'collapse';
  onClick: () => void;
}) => {
  return (
    <Flex mt="20px" onClick={onClick} cursor="pointer">
      <Icon
        icon={type === 'expand' ? 'chevrons-right' : 'chevrons-left'}
        size="medium"
      />
    </Flex>
  );
};
